module.exports = __webpack_public_path__ + "img/1.42b0eaa4.png";